import styles from "./AriaLiveAnnouncer.module.scss"
import { AriaLiveAnnouncerProps } from "./AriaLiveAnnouncer.types"

export default function AriaLiveAnnouncer(props: AriaLiveAnnouncerProps) {
    const { announcement } = props

    return (
        <div aria-live="polite" aria-atomic="true" className={styles.srOnly}>
            {announcement}
        </div>
    )
}
